import React, { useState } from "react";
import PropTypes from "prop-types";
import FormAccordion from "../../../components/Form/FormAccordion";
import ActionSideBar from "../partials/ActionSideBar";
import { StyledForm } from "../../../components/Form/FormComponents.styled";
import { LeaseeInformation, RepairInformationLease } from "../partials/FormFieldsLease";
import { ApprenticeInformation, RepairInformationAF } from "../partials/FormFieldsAF";

// eslint-disable-next-line no-unused-vars
const RepairedForm = ({ requestData, setRequestData, filter }) => {
	const [formData, setFormData] = useState(requestData);
	const [action, setAction] = useState("view");
	const isEditable = action === "edit";
	const isLeasing = filter === "lease";

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleCancel = () => {
		setFormData(requestData);
		setAction("view");
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		console.log(formData);
		setRequestData(formData);
	};

	const updatedData = {
		lease: {
			repairFee: formData?.repairFee,
			fault: formData?.fault,
			repairDueDate: formData?.repairDueDateIP
				? new Date(formData?.repairDueDateIP)
				: formData?.repairDueDate,
			repairStatus: formData?.repairStatus,
		},
		AF: {
			fault: formData?.fault,
			repairFee: formData?.repairFee,
			repairStatus: formData?.repairStatus,
		},
	};

	return (
		<>
			<StyledForm onSubmit={handleSubmit}>
				<ActionSideBar
					requestData={formData}
					action={action}
					setAction={setAction}
					handleCancel={handleCancel}
					updatedData={updatedData}
				/>

				<div className='RightSection'>
					<FormAccordion title='Repair Information' open={true}>
						<div className='grid grid-cols-3 gap-3'>
							{isLeasing ? (
								<RepairInformationLease
									formData={formData}
									isEditable={isEditable}
									handleInputChange={handleInputChange}
								/>
							) : (
								<RepairInformationAF
									formData={formData}
									isEditable={isEditable}
									handleInputChange={handleInputChange}
								/>
							)}
						</div>
					</FormAccordion>

					{isLeasing ? (
						<FormAccordion title='Leasee’s Information' open={true}>
							<LeaseeInformation formData={formData} />
						</FormAccordion>
					) : (
						<FormAccordion title='Apprentice’s Information' open={true}>
							<ApprenticeInformation formData={formData} />
						</FormAccordion>
					)}
				</div>
			</StyledForm>
		</>
	);
};

// Props Validation
RepairedForm.propTypes = {
	requestData: PropTypes.object,
	setRequestData: PropTypes.func,
	filter: PropTypes.string,
};

export default RepairedForm;
